// ABOUTME: Defines shared platform enums used across integrations, workflows, and notifications.
// TODO: will need to merge, left it due to naming
export enum ActivityType {
  AMOS = 'amos',
  LEON = 'leon',
  TECHLOG = 'techlog',
  TRAXXALL = 'traxxall',
  RUSADA = 'rusada',
  NAVBLUE = 'navblue',
  FL3XX = 'fl3xx',
  BLUEONE = 'blueone',
  ASTRO = 'astro',
  CAMP = 'camp',
  RAAS = 'raas',
  SKYLEGS = 'skylegs',
  INTEGRATION_PLATFORM = 'integration_platform',
}

export const ActivityTypeDisplayMap: { [key in ActivityType]: string } = {
  [ActivityType.AMOS]: 'AMOS',
  [ActivityType.LEON]: 'Leon',
  [ActivityType.TECHLOG]: 'Tech Log',
  [ActivityType.TRAXXALL]: 'Traxxall',
  [ActivityType.RUSADA]: 'Rusada',
  [ActivityType.NAVBLUE]: 'Navblue',
  [ActivityType.FL3XX]: 'Fl3xx',
  [ActivityType.BLUEONE]: 'Blueone',
  [ActivityType.ASTRO]: 'Astro',
  [ActivityType.CAMP]: 'CAMP',
  [ActivityType.RAAS]: 'RAAS',
  [ActivityType.SKYLEGS]: 'Skylegs',
  [ActivityType.INTEGRATION_PLATFORM]: 'Integration Platform',
};

export enum Source {
  AMOS = 'AMOS',
  LEON = 'LEON',
  TECHLOG = 'TECHLOG',
  TRAXXALL = 'TRAXXALL',
  RUSADA = 'RUSADA',
  NAVBLUE = 'NAVBLUE',
  FL3XX = 'FL3XX',
  BLUEONE = 'BLUEONE',
  ASTRO = 'ASTRO',
  CAMP = 'CAMP',
  RAAS = 'RAAS',
  SKYLEGS = 'SKYLEGS',
}

/**
 * Maps the `Source` value stored on a config to the `ActivityType` value used as
 * the `{integrationType}` segment of a `data/{integrationType}/{operatorId}/…`
 * path. The two differ in case, so a path built from a config's `Source` without
 * this map addresses a collection that does not exist.
 */
export const SOURCE_TO_ACTIVITY_TYPE: Record<Source, ActivityType> = {
  [Source.AMOS]: ActivityType.AMOS,
  [Source.LEON]: ActivityType.LEON,
  [Source.TECHLOG]: ActivityType.TECHLOG,
  [Source.TRAXXALL]: ActivityType.TRAXXALL,
  [Source.RUSADA]: ActivityType.RUSADA,
  [Source.NAVBLUE]: ActivityType.NAVBLUE,
  [Source.FL3XX]: ActivityType.FL3XX,
  [Source.BLUEONE]: ActivityType.BLUEONE,
  [Source.ASTRO]: ActivityType.ASTRO,
  [Source.CAMP]: ActivityType.CAMP,
  [Source.RAAS]: ActivityType.RAAS,
  [Source.SKYLEGS]: ActivityType.SKYLEGS,
};

export enum Destination {
  AMOS = 'AMOS',
  LEON = 'LEON',
  TECHLOG = 'TECHLOG',
  TRAXXALL = 'TRAXXALL',
  RUSADA = 'RUSADA',
  NAVBLUE = 'NAVBLUE',
  FL3XX = 'FL3XX',
  BLUEONE = 'BLUEONE',
  ASTRO = 'ASTRO',
  CAMP = 'CAMP',
  RAAS = 'RAAS',
  SKYLEGS = 'SKYLEGS',
}

// ActionType represents the sync action to perform on a destination entity.
// While CREATE/UPDATE/DELETE mirror REST semantics, domain-specific actions like DEFER and CLOSE
// enable precise control over integration-specific API calls (e.g., PUT /v1/Defects/{id}/Defer).
// Action-specific schemas and handlers are registered per-path in the TransformationFactory.
export enum ActionType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  DEFER = 'DEFER',
  CLOSE = 'CLOSE',
  LINK_TO_SECTOR = 'LINK_TO_SECTOR',
}

export enum EntityType {
  FLIGHT = 'FLIGHTS',
  DEFECT = 'DEFECTS',
  UPLIFT = 'UPLIFTS',
  RELEASE = 'RELEASES',
  TRIP = 'TRIPS',
  TRIP_UPDATE = 'TRIP_UPDATES',

  // AMOS Source
  PLANNED_FLIGHT = 'PLANNED_FLIGHTS',
  WORKPACKAGE = 'WORKPACKAGE', // AMOS terminology
  WORKPACK = 'WORKPACK', // TechLog terminology
  MXITEM = 'MX_ITEM',

  WORKPLANNER = 'WORKPLANNER',
  DUE_LIST = 'DUE_LIST',
  TOTALS = 'TOTALS',

  USERS = 'USERS',

  OIL_AND_FUEL = 'OIL_AND_FUEL',
  OIL_UPLIFT = 'OIL_UPLIFT',
}

export enum WORKPACKAGE_CLASSIFICATIONS {
  HEAVY = 'H',
  LINE = 'L',
  '' = 'N',
  HIDDEN = 'Y',
}

export enum TripDataType {
  Trip = 'trip',
  Flight = 'flight',
}

export enum WorkorderSource {
  P = 'P',
  M = 'M',
  C = 'C',
}

export enum NotificationErrorType {
  AmosDefects = 'AMOS_DEFECTS',
  AmosFlights = 'AMOS_FLIGHTS',
  AmosUplifts = 'AMOS_UPLIFTS',
  LeonFlights = 'LEON_FLIGHTS',
  AmosUsers = 'AMOS_USERS',
  AmosWorkpackages = 'AMOS_WORKPACKAGES',
  CampActuals = 'CAMP_ACTUALS',
  CampDefects = 'CAMP_DEFECTS',
  PollingDelay = 'POLLING_DELAY',
  PollingItemDelay = 'POLLING_ITEM_DELAY',
  TransmormerSyncFailures = 'TRANSMORMER_SYNC_FAILURES',
  IntegrationDisabled = 'INTEGRATION_DISABLED',
}

export enum Status {
  confirmed = 'confirmed',
  planned = 'planned',
  complete = 'complete',
}

export enum LoggerLabel {
  Worker = 'worker',
  Workflow = 'workflow',
  Activity = 'activity',
}

export enum TripCategory {
  commercial = 'commercial',
  private = 'private',
}

export enum JourneyStatus {
  closed = 'closed',
  open = 'open',
}

export enum SkipItemTypes {
  trips = 'trips',
  navFlight = 'navflight',
}

export enum TechlogCreationMethods {
  STANDARD = 'standard',
  GROUP_BY_DATE = 'groupByDate',
  ONE_TRIP_ONE_FLIGHT = '1trip:1flight',
}

export enum RusadaDefectCategory {
  COMPONENT_DEFECT = 3,
  DEFECT = 2,
}

export enum RusadaDefectType {
  MAREP = 1,
  PIREP = 2,
}

export const AstroPostFlightStatus = {
  COMPLETE: {
    ID: 1,
    Text: 'Completed',
  },
} as const;

export const NotificationSettings = {
  emailDelayMinutes: 10,
  pollingDelayThreshold: 10,
} as const;

export enum PipelineType {
  POLLING = 'POLLING',
  EVENT = 'EVENT',
}

export enum EventType {
  TRANSFORM = 'TRANSFORM',
  PROXY = 'PROXY',
}
